/// <amd-module name="Artifacts/Root/helpers/FeedPerformanceHelper" />
import { PerfScenarios } from "Artifacts/Root/Constants";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssPerformanceService, IVssScenario } from "VSS/Platform/Performance";

export class FeedPerformanceHelper {
  public static split(
    pageContext: IVssPageContext,
    timingName: string,
    scenarioName?: string | undefined,
  ): void {
    const performanceService = pageContext.getService<IVssPerformanceService>(
      "IVssPerformanceService",
    );
    performanceService.addSplitTiming(timingName, scenarioName);
  }

  public static startScenario(
    pageContext: IVssPageContext,
    scenarioName: string,
    isPageInteractive = false,
  ): IVssScenario {
    const performanceService = pageContext.getService<IVssPerformanceService>(
      "IVssPerformanceService",
    );
    return performanceService.startScenario(scenarioName, isPageInteractive);
  }

  public static endScenario(
    pageContext: IVssPageContext,
    scenario: string | IVssScenario,
    isPageInteractive = false,
  ): void {
    let scenarioName = "";
    if (typeof scenario == "object") {
      scenarioName = scenario.scenarioName;
    } else {
      scenarioName = scenario;
    }
    const performanceService = pageContext.getService<IVssPerformanceService>(
      "IVssPerformanceService",
    );
    performanceService.endScenario(PerfScenarios.Area, scenarioName, isPageInteractive);
  }
}
